import DiceLogo from '../DiceLogo';

export default function RewardModal({ show, onClose, playerName, timeText, venueName }) {
  if (!show) return null;

  return (
    <div className="blurred-app-state">
      <div className="emoji-float e1">🍻</div>
      <div className="emoji-float e2">🥨</div>
      <div className="emoji-float e3">🎉</div>
      <div className="emoji-float e4">🍻</div>
      <div className="emoji-float e5">🎲</div>

      <div className="reward-card">
        <DiceLogo style={{ width: 80, height: 80, marginBottom: 10 }} />
        <div className="reward-header">
          <h1 className="reward-title">dice dice baby.</h1>
          <div className="reward-tagline">There's nothing vanilla about it...</div>
        </div>
        <div className="reward-congrats">
          Congrats, <span>{playerName}</span>! You've been rolling for{' '}
          <span className="highlight-time">{timeText}</span> at...
        </div>
        <div className="reward-venue">{venueName}</div>
        <div className="reward-unlocked-label">REWARD UNLOCKED</div>
        <div className="reward-offer-box">
          <div className="reward-offer-text">10% OFF YOUR NEXT ROUND</div>
        </div>
        <div className="reward-qr-container">
          <div className="reward-qr-placeholder"></div>
          <div className="reward-qr-caption">Scan code for 10% off</div>
          <div className="reward-redeem-text">Redeem at the bar</div>
        </div>
        <button className="btn-bank reward-close-btn" onClick={onClose}>🍻 Cheers!</button>
        <div className="reward-wallet-link">Save to Wallet</div>
      </div>
    </div>
  );
}
